import { motion } from 'framer-motion';
import SignupForm from '../components/AuthComps/SignupForm';
import PageTitle from '../components/CommonComps/Titles/PageTitle';

const Signup = () => {
  // rendering signup page component here
  return (
    <main className='font-lato overflow-x-hidden'>
      <PageTitle title='Signup' />

      <section className='grid grid-cols-1 xl:grid-cols-2 min-h-screen'>
        <motion.div
          initial={{ x: -500, opacity: 0 }}
          animate={{
            x: 0,
            opacity: 1,
            transition: {
              ease: 'easeInOut',
              duration: 0.4,
            },
          }}
          className='relative hidden xl:block m-4 rounded-xl overflow-hidden'
        >
          <img
            className='h-full object-cover'
            src='/assets/images/legal_signup.jpg'
            alt='legal sign up banner'
          />

          <div className='absolute flex items-center p-6 inset-0 bg-black/40 size-full'>
            <h1 className='text-7xl 2xl:text-8xl font-bold text-white'>
              Your journey to
              <br />{' '}
              <span className='text-legal-brown font-noto italic'>
                legal clarity
              </span>{' '}
              <br />
              begins.
            </h1>
          </div>
        </motion.div>

        <SignupForm />
      </section>
    </main>
  );
};

export default Signup;
